import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { SeoService } from 'src/app/shared/services/angular-service/seo.service';

@Component({
  selector: 'app-feed-details-page',
  templateUrl: './feed-details-page.component.html',
  styleUrls: ['./feed-details-page.component.scss']
})
export class FeedDetailsPageComponent implements OnInit {
  deviceType;
  constructor(
    private seoService: SeoService,
    private localStorage: LocalStorageService
  ) { }

  ngOnInit(): void {
    this.seoService.getSeo('feed');
    this.deviceType = localStorage.getItem('deviceType')
  }

}
